import { useEffect, useState } from 'react';
import { CURRENT_LOCATION_ID } from '../util/googleMaps';
import { useGeocoder } from '../services/GeocoderGoogleMaps';

const currentLocationData = {
    id: CURRENT_LOCATION_ID,
    predictionPlace: {},
};

/**
 * Resolve entity - user or listing - location lat lng from
 * location object {"lat": "",  "lng": ""}, or request it via Geo API
 * @param {object} param0 - location, { lat: number, lng: number }
 * @returns { origin: {lat, lng} }
 */
export const useCurrentEntityLocation = ({ location, allowed = true }) => {
    const [currentEntityLocationData, setCurrentEntityLocationData] = useState(null);

    const geocoder = useGeocoder();
    const { lat, lng } = location || {};

    useEffect(() => {
        if (!allowed) return;

        if (lat && lng) {
            setCurrentEntityLocationData({ origin: { lat, lng } });
        } else {
            geocoder.getPlaceDetails(currentLocationData).then(response => {
                setCurrentEntityLocationData(response);
            });
        }
    }, [lat, lng, allowed]);

    return currentEntityLocationData;
};
